module.exports = __webpack_public_path__ + "img/030f41ccc82580d3e2c8eb692c14b7f.6cfb214a.png";